import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// ICON
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import {
  GridColDef,
  GridSelectionModelChangeParams,
} from '@material-ui/data-grid';
import { Iobject, Ioption } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { isType, isTypeBK, userTypeList, localeTw } from 'main_consts';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import Select from 'components/Material/Select';
import CheckBox from 'components/Material/Checkbox';
import { AgGridReact } from 'ag-grid-react';
import {
  CellKeyDownEvent,
  ColDef,
  Column,
  FullWidthCellKeyDownEvent,
  GridOptions,
  GridOptionsWrapper,
  RowNode,
  SelectionChangedEvent,
} from 'ag-grid-community';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
// component
import Menu from '../../../components/Menu';
import {
  getDateDayPlus,
  getColWidthByField,
  getWarehouse,
  inputChange,
  radioChange,
  getExpressName,
  formatDate,
  formatDateTime,
  selectChange,
  checkboxChange,
  getEhuFunctionChk,
  initWhrehhouse,
  EhuFunctionChkResult,
  startDateAfterLast3monthVerify,
  getFindDropDownList,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  postDownloadDutyFile,
  postAsynchronousDownloadDutyFile,
  IGetDownloadDutyFileParam,
  postSearch,
  snackBarRsp,
  postExcel,
} from '../../../main_api';
import Table from '../../../components/Material/Table/index';
import { Imaster, Iresult, ISearchData } from './type';
import QryInput from './QryInput';

/** 調閱電子稅單 */
const DutyNoQryDld = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, boxNo, uvFlag, locationCode } =
    useSelector(getUserInfoRedux);
  const { enqueueSnackbar } = useSnackbar();
  const getDefaultValueByName = (
    name: string
  ): string | '' | 'A' | 'B' | 'C' | 'D' => {
    switch (name) {
      // 箱號
      case 'boxNo':
        if (isType(userTypeList.type3, userType)) {
          // #region 報關業者自動帶出【報關箱號】
          return boxNo;
          // #endregion
        }
        break;

      // 所屬關別
      case 'customId':
        if (isType(userTypeList.type3, userType)) {
          // #region  報關業者自動帶出【所屬關別】
          // USERTYPE = ABKK[空-高雄]，則關別為"B"
          // USERTYPE = ABKT[空-台北]，則關別為"C"
          // USERTYPE = SBKE[海-基隆]，則關別為"A"
          // USERTYPE = SBKG[海-台中]，則關別為"D"
          // USERTYPE = SBKK[海-高雄]，則關別為"B"
          switch (userType) {
            case 'SBKE':
              return 'A';

            case 'SBKK':
            case 'ABKK':
              return 'B';

            case 'ABKT':
              return 'C';

            case 'SBKG':
              return 'D';

            default:
          }

          // #endregion
        } else if (isType(userTypeList.type4, userType)) {
          // #region  海關自動帶入【所屬關別】
          switch (userType) {
            case 'DKEL':
              return 'A';

            case 'DKHH':
              return 'B';

            case 'DTPE':
              return 'C';

            case 'DTXG':
              return 'D';

            default:
              break;
          }
          // #endregion
        }

        break;

      default:
        break;
    }
    return '';
  };

  const [EhuFunctionChk, setEhuFunctionChkResult] =
    useState<EhuFunctionChkResult>({
      aspUserId: '',
      userName: '',
      usertype: '',
      locationCode: '',
      boxNo: '',
      ban: '',
      asType: '',
      chkCode1: '',
      chkCode2: '',
      chkCode3: '',
      userId: '',
      updTime: '',
      roleType: '',
      sender_id: '',
      uvFlag: '',
      boxno1: '',
    });
  const getFileNameType = (): string => {
    if (EhuFunctionChk.roleType === '1') {
      return 'HAWB_NO';
    }

    return 'NORMAL';
  };
  const masterDefaultValue: Imaster = {
    downloadType: '0',
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    mawbNo: '',
    boxNo: getDefaultValueByName('boxNo'),
    boxNoSub: '',
    customId: getDefaultValueByName('customId'),
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    dutyPayerId: '',
    qryType: '1',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    endDateValid: false,
    startDateValid: false,

    qryInputType1: '1',
    qryInputType2: '1',
    qryInputType3: '1',
    qryInputType4: '1',
    qryInputType5: '1',
    qryInputType6: '1',
    qryInputType7: '1',
    qryInputType8: '1',
    qryInputType9: '1',
    qryInputType10: '1',

    mawb1: '',
    mawb2: '',
    mawb3: '',
    mawb4: '',
    mawb5: '',
    mawb6: '',
    mawb7: '',
    mawb8: '',
    mawb9: '',
    mawb10: '',

    hawb1: '',
    hawb2: '',
    hawb3: '',
    hawb4: '',
    hawb5: '',
    hawb6: '',
    hawb7: '',
    hawb8: '',
    hawb9: '',
    hawb10: '',

    dutyNo1: '',
    dutyNo2: '',
    dutyNo3: '',
    dutyNo4: '',
    dutyNo5: '',
    dutyNo6: '',
    dutyNo7: '',
    dutyNo8: '',
    dutyNo9: '',
    dutyNo10: '',

    sortType: '0',
    ban: '',
    defDutyCode: '',
    declNo: '',
    defDutyMark1: '',
    defDutyMark2: '',
    fileNameType: '',
  };

  const apiName = 'dutyNoQryDld';
  const [formError, setFormError] = useState(false);
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [fileNameTypeOptions, setFileNameTypeOptions] = useState<Ioption[]>([]);

  const [roleType, setRoleType] = useState('*');

  const [searchPara, setSearchPara] = useState<IGetDownloadDutyFileParam>({
    qryType: '1',
    sortType: '0',
    ban: '',
    defDutyCode: '',
    declNo: '',
    importStartDate: '',
    importEndDate: '',
    gcoStartDate: '',
    gcoEndDate: '',
    mawbNo: '',
    chkCode1: '',
    warehouse: '',
    boxNo: '',
    customId: '',
    downloadType: '0',
    mawbNoAndHawbNoList: [{ mawbNo: '', hawbNo: '' }],
    dutyNoList: [],
    downloadDutyNoList: [],
    defDutyMark1: '',
    defDutyMark2: '',
    fileNameType: '',
  });
  // #1 chkCode1 記帳代碼
  const [chkCode1Options, setChkCode1Options] = useState<Ioption[]>([]);
  const [chkCode1Show, setChkCode1Show] = useState(true);
  const [chkCode1Type, setChkCode1Type] = useState<'INPUT' | 'SELECT'>('INPUT');
  // #2 customId
  const [customIdRequired, setCustomIdRequired] = useState(false);
  const [customIdDisabled, setCustomIdDisabled] = useState(false);
  const [customIdTitle, setCustomIdTitle] = useState('所屬關別：');
  // warehouse
  const [warehouseShow, setWarehouseShow] = useState(true);
  const [randomValue, setRandomValue] = useState(Math.random());
  // boxNo
  const [boxNoDisabled, setBoxNoDisabled] = useState(false);

  // defDutyCode
  const [defDutyCodeShow, setDefDutyCodeShow] = useState(false);
  // ban
  const [banShow, setBanShow] = useState(false);
  // PSP
  const [isPSPShow, setIsPSPShow] = useState(true);
  // table
  const [tbSelectList, setTbSelectList] = useState<RowNode[]>([]);

  const [sortOptions, setSortOptions] = useState<Ioption[]>([]);
  const [qryOptions, setQryOptions] = useState<Ioption[]>([]);

  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        // headerCheckboxSelection: roleType === '1',
        // headerCheckboxSelectionFilteredOnly: roleType === '1',
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '下載時間',
        field: 'infoRec',
        width: 300,
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '分號',
        field: 'hawbNo',
        width: 300,
      },
      {
        headerName: '稅單號碼',
        field: 'dutyNo',
        width: 300,
      },
      {
        headerName: '稅單金額',
        field: 'totalDutyAmt',
        width: 150,
      },
      {
        headerName: '營業稅稅基',
        field: 'taxBasis',
        width: 150,
      },
      {
        headerName: '進口納稅義務人',
        field: 'dutyPayerNameC',
        width: 300,
      },
      {
        headerName: '進口日期',
        field: 'importDate',
        width: 300,
      },
      {
        headerName: '下載用戶',
        field: 'userId',
        width: 300,
      },
      {
        headerName: '授權統編',
        field: 'defDutyCode',
        width: 150,
        hide: status,
      },
      {
        headerName: '自定義欄1',
        field: 'defDutyMark1',
        width: 200,
        hide: status,
      },
      {
        headerName: '自定義欄2',
        field: 'defDutyMark2',
        width: 200,
        hide: status,
      },
    ];
  };

  const onFirstDataRendered = (params: any) => {
    // params.api.sizeColumnsToFit();
  };

  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
      // colResizeDefault: 'shift',
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  const handleDownloadDetail = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    // 1 => 主分號 2 => 稅單號碼
    const type1Result: { mawbNo: string; hawbNo: string }[] = [];
    const type2Result: string[] = [];

    if (master.qryType === '2') {
      for (let i = 1; i <= 10; i += 1) {
        if (master[`qryInputType${i}`] === '1') {
          if (
            (master[`mawb${i}`] as string).length > 0 ||
            (master[`hawb${i}`] as string).length > 0
          ) {
            type1Result.push({
              mawbNo: master[`mawb${i}`] as string,
              hawbNo: master[`hawb${i}`] as string,
            });
          }
        } else if ((master[`dutyNo${i}`] as string).length > 0) {
          type2Result.push(master[`dutyNo${i}`] as string);
        }
      }
    }

    const para = {
      chkCode1: chkCode1Show ? master.chkCode1 : '',
      warehouse: warehouseShow ? master.warehouse : '',
      boxNo: `${master.boxNo}${master.boxNoSub}`,
      customId: master.customId,
      qryType: master.qryType,
      sortType: master.sortType,
      importStartDate:
        master.qryType === '1' ? formatDate(master.startDate, 'yyyyMMdd') : '',
      importEndDate:
        master.qryType === '1' ? formatDate(master.endDate, 'yyyyMMdd') : '',
      gcoStartDate:
        master.qryType === '4'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      gcoEndDate:
        master.qryType === '4'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
      mawbNo: master.qryType === '3' ? master.mawbNo : '',

      updTimeStartDate:
        master.qryType === '5'
          ? formatDateTime(
              master.startDate,
              `${master.startTime}00`,
              'yyyyMMddHHmmss'
            )
          : '',
      updTimeEndDate:
        master.qryType === '5'
          ? formatDateTime(
              master.endDate,
              `${master.endTime}59`,
              'yyyyMMddHHmmss'
            )
          : '',
      declNo: '',
      ban: master.ban,
      defDutyCode: master.defDutyCode,
      mawbNoAndHawbNoList: type1Result,
      dutyNoList: type2Result,
      downloadType: master.downloadType,
      defDutyMark1: master.defDutyMark1,
      defDutyMark2: master.defDutyMark2,
    };
    setSearchPara({ ...para, downloadDutyNoList: [] });

    const result = await postExcel(apiName, para);

    blobDownload(
      result,
      enqueueSnackbar,
      `${EhuFunctionChk.aspUserId}_${
        master.qryType === '1' ||
        master.qryType === '4' ||
        master.qryType === '5'
          ? `${formatDate(master.startDate, 'MMdd')}_${formatDate(
              master.endDate,
              'MMdd'
            )}`
          : formatDate(getDateDayPlus(), 'MMdd')
      }_調閱電子稅單.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };
  // const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
  //   try {
  //     if (e && e.preventDefault) {
  //       e.preventDefault();
  //     }
  //     dispatch(setLoadingRedux(true));

  //     const type3Result: string[] = [];

  //     tbSelectList.forEach((v) => {
  //       return type3Result.push(rowData[Number(v)].dutyNo);
  //     });
  //     const para: IGetDownloadDutyFileParam = {
  //       ...searchPara,
  //       downloadDutyNoList: type3Result,
  //     };

  //     // const result = await postSaveDutyFile(para);

  //     const result = await postDownloadDutyFile(para);
  //     const contentDisposition = String(result.headers['content-disposition']);
  //     const fileName = contentDisposition.slice(
  //       contentDisposition.indexOf('filename') + 9,
  //       contentDisposition.length
  //     );
  //     snackBarRsp(enqueueSnackbar, result);
  //     blobDownload(result, enqueueSnackbar, fileName || 'emptyName.zip');
  //     dispatch(setLoadingRedux(false));
  //   } catch (error) {
  //     dispatch(setLoadingRedux(false));
  //   }
  // };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const type3Result: string[] = [];

    // tbSelectList.forEach((v) => {
    //   return type3Result.push(rowData[Number(v)].dutyNo);
    // });
    // tbSelectList.forEach((v) => {
    //   return type3Result.push(v.data.dutyNo);
    // });
    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      // console.log('selectedDatas', selectedDatas);
      selectedDatas.forEach((node: any) => {
        // console.log('forEach', node.data.dutyNo);
        return type3Result.push(node.data.dutyNo);
      });
    } else {
      enqueueSnackbar('請先選擇稅單資料');
      return;
    }

    const para: IGetDownloadDutyFileParam = {
      ...searchPara,
      fileNameType: master.fileNameType
        ? master.fileNameType
        : getFileNameType(),
      downloadDutyNoList: type3Result,
    };
    dispatch(setLoadingRedux(true));

    const saveExcelResult = await postAsynchronousDownloadDutyFile(para);
    dispatch(setLoadingRedux(false));
    snackBarRsp(enqueueSnackbar, saveExcelResult);
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    // 1 => 主分號 2 => 稅單號碼
    const type1Result: { mawbNo: string; hawbNo: string }[] = [];
    const type2Result: string[] = [];
    if (master.qryType === '2') {
      for (let i = 1; i <= 10; i += 1) {
        if (master[`qryInputType${i}`] === '1') {
          if (
            (master[`mawb${i}`] as string).length > 0 ||
            (master[`hawb${i}`] as string).length > 0
          ) {
            type1Result.push({
              mawbNo: master[`mawb${i}`] as string,
              hawbNo: master[`hawb${i}`] as string,
            });
          }
        } else if ((master[`dutyNo${i}`] as string).length > 0) {
          type2Result.push(master[`dutyNo${i}`] as string);
        }
      }
    }

    const para = {
      chkCode1: chkCode1Show ? master.chkCode1 : '',
      warehouse: warehouseShow ? master.warehouse : '',
      boxNo: `${master.boxNo}${master.boxNoSub}`,
      customId: master.customId,
      qryType: master.qryType,
      sortType: master.sortType,
      importStartDate:
        master.qryType === '1' ? formatDate(master.startDate, 'yyyyMMdd') : '',
      importEndDate:
        master.qryType === '1' ? formatDate(master.endDate, 'yyyyMMdd') : '',
      gcoStartDate:
        master.qryType === '4'
          ? formatDateTime(master.startDate, `${master.startTime}00`)
          : '',
      gcoEndDate:
        master.qryType === '4'
          ? formatDateTime(master.endDate, `${master.endTime}59`)
          : '',
      mawbNo: master.qryType === '3' ? master.mawbNo : '',
      updTimeStartDate:
        master.qryType === '5'
          ? formatDateTime(
              master.startDate,
              `${master.startTime}00`,
              'yyyyMMddHHmmss'
            )
          : '',
      updTimeEndDate:
        master.qryType === '5'
          ? formatDateTime(
              master.endDate,
              `${master.endTime}59`,
              'yyyyMMddHHmmss'
            )
          : '',
      declNo: '',
      ban: master.ban,
      defDutyCode: master.defDutyCode,
      mawbNoAndHawbNoList: type1Result,
      dutyNoList: type2Result,
      downloadType: master.downloadType,
      defDutyMark1: master.defDutyMark1,
      defDutyMark2: master.defDutyMark2,
    };
    setSearchPara({ ...para, downloadDutyNoList: [] });

    const result = await postSearch(apiName, para);
    let resultData = (result.data.data as Iresult[]) || [];

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    if (resultData.length > 0) {
      if (resultData.length > 5000 && master.qryType !== '3') {
        enqueueSnackbar('本次查詢已超過5000筆，請縮小範圍查詢/下載');
        const length = resultData.length - 5000;
        resultData = resultData.splice(0, 5000);
      }
      // setColList(
      //   getColWidthByField([
      //     { headerName: '', field: 'selected' },
      //     { headerName: '項次', field: 'itemNo' },
      //     { headerName: '下載時間', field: 'infoRec' },
      //     { headerName: '主號', field: 'mawbNo' },
      //     { headerName: '分號', field: 'hawbNo' },
      //     { headerName: '稅單號碼', field: 'dutyNo' },
      //     { headerName: '稅單金額', field: 'totalDutyAmt' },
      //     { headerName: '營業稅稅基', field: 'taxBasis' },
      //     {
      //       headerName: '納稅義務人',
      //       field: 'dutyPayerNameC',
      //     },
      //     { headerName: '進口日期', field: 'importDate' },
      //     { headerName: '下載用戶', field: 'userId' },

      //     {
      //       headerName: '授權稅單統編',
      //       field: 'defDutyCode',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },
      //     {
      //       headerName: '自定義欄1',
      //       field: 'defDutyMark1',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },
      //     {
      //       headerName: '自定義欄2',
      //       field: 'defDutyMark2',
      //       hide: !(
      //         EhuFunctionChk.roleType === '1' &&
      //         (isType(userTypeList.type5, userType) || isTypeBK(userType))
      //       ),
      //     },
      //   ])
      // );

      setRowData(resultData);
      setOpenSearchTable(true);
      const columnDefs = getColumnDefs(
        !(
          EhuFunctionChk.roleType === '1' &&
          (isType(userTypeList.admin, userType) ||
            isType(userTypeList.type5, userType) ||
            isTypeBK(userType))
        )
      );

      gridRef.current!.api.setColumnDefs(columnDefs);
      const allColumnIds: string[] = [];
      gridOptions.columnApi?.getAllColumns()?.forEach((colName) => {
        allColumnIds.push(colName.getColId());
      });
      gridOptions.columnApi?.autoSizeColumns(allColumnIds);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (
      master.qryType === '1' ||
      master.qryType === '4' ||
      master.qryType === '5'
    ) {
      if (
        !master.endDateValid ||
        !master.startDateValid ||
        !(master.startDate && master.endDate)
      ) {
        return;
      }
    }
    if (
      EhuFunctionChk.roleType !== '1' &&
      !isType(userTypeList.admin, userType)
    ) {
      if (
        master.qryType === '1' ||
        master.qryType === '4' ||
        master.qryType === '5'
      ) {
        if (
          !startDateAfterLast3monthVerify(master.startDate, enqueueSnackbar)
        ) {
          return;
        }
      }
    }

    let canQry: boolean;
    canQry = false;
    switch (master.qryType) {
      case '2':
        for (let i = 1; i <= 10; i += 1) {
          if (master[`qryInputType${i}`] === '1') {
            if (
              (master[`mawb${i}`] as string).length > 0 &&
              (master[`hawb${i}`] as string).length > 0
            ) {
              canQry = true;
            }
          } else if ((master[`dutyNo${i}`] as string).length > 0) {
            canQry = true;
          }
        }
        if (!canQry) {
          enqueueSnackbar(`至少要輸入一筆主分號/稅單號碼!`);
        }

        break;
      case '3':
        if (master.mawbNo.trim() !== '') {
          canQry = true;
        } else {
          enqueueSnackbar('【主號】必填。', {
            variant: 'warning',
          });
        }
        break;
      default:
        canQry = true;
        break;
    }

    if (!canQry) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      case 'downloadDetail':
        handleDownloadDetail();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);

    if (chkCode1Type === 'SELECT') {
      if (key[0] === 'chkCode1') {
        const masterTemp = { ...master, ...updateObj };
        const { chkCode1 } = masterTemp;
        const name = warehouseRedux.filter((v) => v.chkCode1 === chkCode1)[0]
          .expressName;
        setExpressName(name);
        setMaster((prev) => ({
          ...prev,
          boxNo: warehouseRedux.filter((v) => v.chkCode1 === chkCode1)[0].boxNo,
        }));
      }
    } else if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = () => {
    setRamdom(Math.random());
    setTbSelectList([]);
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );
    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  const tbCheckBoxChange = (e: SelectionChangedEvent) => {
    // const selectedList = e.selectionModel as string[];
    const selectedList = e.api.getSelectedNodes();
    // console.log('onSelectionChanged(selectedNodes):', selectedList);
    // selectedList.forEach((d) => {
    //   console.log(d.data.dutyNo);
    // });
    setTbSelectList(selectedList);
  };

  useEffect(() => {
    getEhuFunctionChk().then((item) => {
      setEhuFunctionChkResult(item);

      const list: Ioption[] = [];
      list.push({ value: '0', label: '' });

      list.push({ value: '1', label: '主號+分號' });
      if (item.chkCode3 === 'Y') {
        list.push({ value: '2', label: '出倉日' });
      }
      list.push({ value: '3', label: '進口日' });
      if (
        userType &&
        (isType(userTypeList.admin, userType) ||
          isType(userTypeList.type5, userType) ||
          isTypeBK(userType)) &&
        item.roleType === '1'
      ) {
        list.push({ value: '4', label: '授權稅單統編' });
        list.push({ value: '5', label: '自定義欄1' });
        list.push({ value: '6', label: '自定義欄2' });
      }

      if (
        userType &&
        (isType(userTypeList.admin, userType) ||
          isType(userTypeList.type4, userType) ||
          isType(userTypeList.topType, userType) ||
          isTypeBK(userType)) &&
        item.roleType === '1'
      ) {
        setDefDutyCodeShow(true);
      }
      if (item.roleType === '1') {
        setRoleType('1');
      }
      setSortOptions(list);

      const qryList: Ioption[] = [];
      qryList.push({ value: '1', label: '進口日期區間' });
      qryList.push({ value: '2', label: '主分號/稅單號碼' });
      qryList.push({ value: '3', label: '主號' });
      if (item.roleType === '1') {
        if (item.chkCode3 === 'Y') {
          qryList.push({ value: '4', label: '出倉日期區間' });
          setMaster((prev) => ({
            ...masterDefaultValue,
            qryType: '4',
          }));
        }
        qryList.push({ value: '5', label: '電子稅單收檔日期' });
        qryList.push({ value: '6', label: '自定欄位' });
      }

      setQryOptions(qryList);

      if (
        userType &&
        !isType(userTypeList.type5, userType) &&
        item.roleType === '1'
      ) {
        setBanShow(true);
      }
      if (item.chkCode3 !== 'Y') {
        setChkCode1Show(false);
        setWarehouseShow(false);
      }
      if (userType && isType(userTypeList.type5, userType)) {
        setIsPSPShow(false);
        setChkCode1Show(false);
        setWarehouseShow(false);
      }
    });

    if (userType !== '') {
      if (isType(userTypeList.type2, userType)) {
        // #region 承攬業者為下拉選單 SELECT 其他是TEXT
        setChkCode1Type('SELECT');
        // #endregion
        // #region  【報關箱號】disabled
        setBoxNoDisabled(true);
        setWarehouseShow(false);
        // #endregion
      } else if (isType(userTypeList.type3, userType)) {
        // #region  報關業者拿掉【記帳帶號】
        setChkCode1Show(false);
        // #endregion
        // #region  報關業者【所屬關別】不開放輸入
        setCustomIdDisabled(true);
        // #endregion

        // #region 【報關箱號】disabled

        setBoxNoDisabled(true);
        setWarehouseShow(false);
        // #endregion
      } else if (isType(userTypeList.type4, userType)) {
        // #region  海關如果沒有locationCode關閉所有按紐功能
        // if (locationCode.trim().length === 0) {
        //   setFormError(true);
        // }
        // #endregion
        // #region  海關拿掉【記帳代號】
        setChkCode1Show(false);
        // #endregion
        // #region  海關【所屬關別】不開放輸入
        setCustomIdDisabled(true);
        setWarehouseShow(false);
        // #endregion
      } else if (isType(userTypeList.topType, userType)) {
        // #region  關務署 開放快遞倉站
        // setWarehouseShow(true);
        // #endregion
      } else if (isType(userTypeList.admin, userType)) {
        // #region  系統管理員 開放快遞倉站
        // setWarehouseShow(true);
        // #endregion
      }

      setMaster((prev) => ({
        ...masterDefaultValue,
        endDateValid: prev.endDateValid,
        startDateValid: prev.startDateValid,
      }));

      getFindDropDownList('findDropDownFileNameType', {}).then((item) => {
        setFileNameTypeOptions(item);
      });
    }
  }, [userType]);

  useEffect(() => {
    // 承攬業者若有輸入【報關箱號】，【所屬關別】為必填。
    if (isType(userTypeList.type2, userType)) {
      setCustomIdRequired(master.boxNo.length > 0);
      setCustomIdTitle(master.boxNo.length > 0 ? '*所屬關別：' : '所屬關別：');
    }
  }, [master.boxNo]);

  useEffect(() => {
    if (chkCode1Type === 'SELECT') {
      const data = warehouseRedux.filter((v) => v.chkCode1 !== '');
      if (data.length > 0) {
        const list: Ioption[] = [];
        data.forEach((val) => {
          list.push({
            value: val.chkCode1,
            label: val.chkCode1,
          });
        });
        setChkCode1Options(list);
        const filtered = warehouseRedux.filter(
          (v) => v.chkCode1 === list[0].value
        );
        if (filtered.length > 0) {
          setExpressName(filtered[0].expressName || '');
          setMaster((prev) => ({
            ...prev,
            chkCode1: filtered[0].chkCode1,
            boxNo: filtered[0].boxNo,
          }));
        }
      }
    }
  }, [warehouseRedux, userType]);

  const pageChange = useCallback(async (pageChangeRoleType: string) => {
    // console.log('pageChange', pageChangeRoleType);
    if (gridRef.current && pageChangeRoleType === '*') {
      await gridRef.current!.api.forEachNode(function (
        node: any,
        index: number
      ) {
        node.setSelected(false);
      });
    }
  }, []);

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex || roleType === '1') {
          index2 = maxIndex;
        }
        if (roleType === '1') {
          index3 = 0;
        }

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex || roleType === '1') {
          index2 = maxIndex;
        }
        if (roleType === '1') {
          index3 = 0;
        }

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };
  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            稅單資料查詢
          </Link>
          <Typography color="textPrimary">調閱電子稅單</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 調閱電子稅單
          </div>
        </div>
        <div className="input-area">
          {chkCode1Show && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                {chkCode1Type === 'INPUT' ? (
                  <Input
                    name="chkCode1"
                    maxLength={4}
                    value={master.chkCode1}
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                ) : (
                  <Select
                    name="chkCode1"
                    value={master.chkCode1}
                    onChange={selectChange(updateData)}
                    options={chkCode1Options}
                    disabled={chkCode1Options.length === 0}
                  />
                )}
              </VcGrid>
              <VcGrid item xs={12} sm={4}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          {warehouseShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>快遞倉站：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <WarehouseModal
                  value={master.warehouse}
                  updateData={updateData}
                  setStatus={setWarehouseName}
                />
              </VcGrid>

              <VcGrid item xs={12} sm={4}>
                {warehouseName && (
                  <Alert
                    severity="info"
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    icon={false}
                  >
                    {warehouseName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}
          {isPSPShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                報關箱號：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="boxNo"
                  disabled={boxNoDisabled}
                  value={master.boxNo}
                  maxLength={3}
                  minLength={3}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
          {isPSPShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                報關箱號附碼：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="boxNoSub"
                  value={master.boxNoSub}
                  maxLength={1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
          {isPSPShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>{customIdTitle}</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  required={customIdRequired}
                  placeholder={
                    isType(userTypeList.type2, userType)
                      ? '有輸入報關箱號，此欄為必填'
                      : ''
                  }
                  maxLength={1}
                  disabled={customIdDisabled}
                  name="customId"
                  value={master.customId}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={7}>
                <span style={{ color: 'red' }}>
                  A：基隆關、B：高雄關、C：台北關、D：台中關
                </span>
              </VcGrid>
            </Grid>
          )}
          {banShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                貨主統編：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="ban"
                  maxLength={14}
                  value={master.ban}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
          {defDutyCodeShow && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                授權稅單統編：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="defDutyCode"
                  maxLength={14}
                  value={master.defDutyCode}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
          {/* <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              排序選項：
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.sortType}
                onChange={selectChange(updateData)}
                name="sortType"
                options={sortOptions}
                // disabled={options.length === 0}
              />
            </VcGrid>
          </Grid> */}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*查詢選項：</FormTitle>
            </VcEGrid>
            <HVcGrid item xs={12} sm={6}>
              <Radio
                className="input-radio "
                required
                name="qryType"
                value={master.qryType}
                onChange={radioChange(updateData)}
                options={qryOptions}
              />
            </HVcGrid>
          </Grid>
          {master.qryType === '1' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>
                  {master.qryType === '1' ? '日期區間：' : '日期區間'}
                </FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
                <DateSePickersTyping
                  required
                  updateData={updateData}
                  style={{ maxWidth: 600 }}
                  names={['startDate', 'endDate']}
                  data={master}
                  seInterval={31}
                />
              </VcGrid>
            </Grid>
          )}
          {master.qryType === '2' && (
            <>
              <QryInput
                index="1"
                value={{
                  mawbVal: master.mawb1,
                  hawbVal: master.hawb1,
                  dutyNoVal: master.dutyNo1,
                  qryInputType: master.qryInputType1,
                }}
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb2,
                  hawbVal: master.hawb2,
                  dutyNoVal: master.dutyNo2,
                  qryInputType: master.qryInputType2,
                }}
                index="2"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb3,
                  hawbVal: master.hawb3,
                  dutyNoVal: master.dutyNo3,
                  qryInputType: master.qryInputType3,
                }}
                index="3"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb4,
                  hawbVal: master.hawb4,
                  dutyNoVal: master.dutyNo4,
                  qryInputType: master.qryInputType4,
                }}
                index="4"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb5,
                  hawbVal: master.hawb5,
                  dutyNoVal: master.dutyNo5,
                  qryInputType: master.qryInputType5,
                }}
                index="5"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb6,
                  hawbVal: master.hawb6,
                  dutyNoVal: master.dutyNo6,
                  qryInputType: master.qryInputType6,
                }}
                index="6"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb7,
                  hawbVal: master.hawb7,
                  dutyNoVal: master.dutyNo7,
                  qryInputType: master.qryInputType7,
                }}
                index="7"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb8,
                  hawbVal: master.hawb8,
                  dutyNoVal: master.dutyNo8,
                  qryInputType: master.qryInputType8,
                }}
                index="8"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb9,
                  hawbVal: master.hawb9,
                  dutyNoVal: master.dutyNo9,
                  qryInputType: master.qryInputType9,
                }}
                index="9"
                fatherUpdateData={updateData}
              />
              <QryInput
                value={{
                  mawbVal: master.mawb10,
                  hawbVal: master.hawb10,
                  dutyNoVal: master.dutyNo10,
                  qryInputType: master.qryInputType10,
                }}
                index="10"
                fatherUpdateData={updateData}
              />
            </>
          )}
          {master.qryType === '3' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                主號：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="mawbNo"
                  value={master.mawbNo}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
          {master.qryType === '4' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>出倉日期區間：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={31}
                />
              </VcGrid>
            </Grid>
          )}
          {master.qryType === '5' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>電子稅單收檔日期區間：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
                <DateTimeSePickersTyping
                  key={random}
                  required
                  updateData={updateData}
                  style={{ maxWidth: 800 }}
                  names={[
                    ['startDate', 'startTime'],
                    ['endDate', 'endTime'],
                  ]}
                  data={master}
                  setDayRange={31}
                />
              </VcGrid>
            </Grid>
          )}
          {master.qryType === '6' && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                自訂欄位1：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="defDutyMark1"
                  value={master.defDutyMark1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcEGrid item xs={12} sm={2} className="input-text">
                自訂欄位2：
              </VcEGrid>
              <VcGrid item xs={12} sm={3}>
                <Input
                  name="defDutyMark2"
                  value={master.defDutyMark2}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
            </Grid>
          )}
        </div>
        {EhuFunctionChk.roleType === '1' && (
          <>
            <Grid container>
              <>
                <VcEGrid item xs={undefined} sm={2} />
                <VcGrid item xs={12} sm>
                  <CheckBox
                    label="未下載稅單查詢"
                    checked={master.downloadType === '1'}
                    name="downloadType"
                    onChange={(e) => {
                      setMaster((prev) => ({
                        ...prev,
                        ...checkboxChange()(['1', '0'])(e),
                      }));
                    }}
                  />
                </VcGrid>
              </>
            </Grid>

            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>檔名類型：</FormTitle>
              </VcEGrid>
              <Grid item xs={12} sm={3}>
                <Select
                  value={master.fileNameType}
                  onChange={selectChange(updateData)}
                  name="fileNameType"
                  options={fileNameTypeOptions}
                  // disabled={options.length === 0}
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                formError ||
                // tbSelectList.length === 0 ||
                !openSearchTable ||
                isType(userTypeList.type4, userType) ||
                isType(userTypeList.admin, userType) ||
                isType(userTypeList.topType, userType)
              }
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載稅單
            </Button>
          </Grid>

          <Grid item xs={12} sm="auto">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('downloadDetail')}
            >
              下載稅單PDF_Excel
            </Button>
          </Grid>
          <Grid container>
            <div
              style={{
                color: 'red',
                fontWeight: 800,
                marginLeft: '10%',
                padding: 0,
              }}
            >
              1.X類轉G類報單者，無稅單資料可查。
            </div>
          </Grid>
          <Grid container>
            <div
              style={{
                color: 'red',
                fontWeight: 800,
                marginLeft: '10%',
                padding: 0,
              }}
            >
              2.滑鼠指到欲排序欄位同時按壓「Ctrl」鍵，即可達成排序效果。
            </div>
          </Grid>
          <Grid container>
            <div
              style={{
                color: 'red',
                fontWeight: 800,
                marginLeft: '10%',
                padding: 0,
              }}
            >
              3.稅單查詢與調閱，只留存3個月，已採購稅單雲者除外。
            </div>
          </Grid>
        </Grid>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              {EhuFunctionChk.roleType === '1' ? '全選' : '此頁全選'}
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              {EhuFunctionChk.roleType === '1' ? '全不選' : '此頁取消全選'}
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        // <Table
        //   key={randomValue}
        //   data={rowData as unknown as Iobject[]}
        //   columns={colList}
        //   rowsPerPageOptions={[100, 50, 10]}
        //   rootProps={{ style: { height: '400px' } }}
        //   pageSize={100}
        //   onSelectionModelChange={(e) => tbCheckBoxChange(e)}
        // />

        <div className="ag-theme-alpine" style={{ height: '400px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            onFirstDataRendered={onFirstDataRendered}
            // onSelectionChanged={(e) => tbCheckBoxChange(e)}
            onPaginationChanged={() => pageChange(roleType)}
          />
        </div>
      )}
    </div>
  );
};

export default DutyNoQryDld;
